var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.company)?_c('router-link',{staticClass:"company-link",attrs:{"to":'/companies/' + _vm.company.id}},[_c('lazy-background',{staticClass:"round",attrs:{"src":_vm.company.image_source.thumb100}}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.company.name))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }